import MyOrders from '@vue-storefront/core/compatibility/components/blocks/MyAccount/MyOrders'
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'UserOrders',
  mixins: [MyOrders],
  data () {
    return {
      pagination: {
        perPage: 10,
        current: 1,
        enabled: false
      },
      lazyLoadOrdersOnScroll: true,
      orderForPay: {}
    }
  },
  computed: {
    ...mapGetters({
      lastPage: 'user/getLastOrderHistoryPage',
      location: 'locations/getActiveLocation'
    }),
    ordersHistory () {
      let items = this.getOrdersHistory
      if (items.length > 0) {
        if (this.lazyLoadOrdersOnScroll) {
          items = items.slice(0, (this.pagination.perPage + 1) * this.pagination.current)
        }
      }
      return items
    }
  },
  methods: {
    ...mapActions({
      'ordersHistoryAction': 'user/getOrdersHistory',
      loadPartners: 'partners/loadPartners',
      clearOrderHistory: 'user/clearOrderHistory',
      getOneOrder: 'user/getOneOrder'
    }),
    async loadOrders ($state) {
      if (!this.ordersHistory.length) {
        this.pagination.current = 0;
      }
      if (this.pagination.current < this.lastPage) {
        ++this.pagination.current
        await this.ordersHistoryAction({
          refresh: true,
          useCache: false,
          page: this.pagination.current,
          oldLocationCode: this.location.code,
          locationCode: this.location.code
        }).finally(() => {
          $state.loaded()
        })
      } else {
        $state.complete()
      }
    }
  },
  destroyed () {
    this.pagination.current = 1;
  }
}
